import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import toastr from 'toastr';
import Form from '../../utility/Form';
import { login,getcsrf } from '../../actions/auth/Login';
import { SubmitButton } from "../../components/form/SubmitButton";
import '../../assets/js/jquery.particleground.js';
import img from '../../assets/images/Raseel_Vertical.jpg';
import img2 from "../../assets/images/TATA-Communications-Logo-Blue-Hor-New.png";
import { tataLogoText, tataLogo } from '../../components/Images';
import Delete from '../../components/grid/modalpopup';
import LocaleSelector from "../../locale/localeSelector";
import { MdVerifiedUser } from "react-icons/md";
class Login extends Component {
    /*Handling events with React elements is very similar to handling events on DOM elements
   * Inside a loop it is common to want to pass an extra parameter to an event handler.
   *the e argument representing the React event will be passed as a second argument after the ID.
   *With an arrow function, we have to pass it explicitly,
   *but with bind any further arguments are automatically forwarded
   *The bind() method creates a new function that, when called, has its this keyword set to the provided value
   *An arrow function expression has a shorter syntax than a function expression and does not have its own this, arguments, super, or new.target
   */
    constructor(props) {
        super(props);
		 var CryptoJS = require("crypto-js");
        var passKey = "my-secret-key@12";
        // set the rules & dispatch action of signin form
        this.signin = Form.getInstance(
            this,
            { 'userName': 'required', 'password': 'required', 'captcha': 'required'},
            (fields) => {
					//console.log(fields)
				    if(fields.password){
                    // console.log("encode values=", btoa(values.password))
                    // values.password = btoa(values.password)
                    var key  = CryptoJS.enc.Latin1.parse(passKey);
                    var iv   = CryptoJS.enc.Latin1.parse(passKey); 
                    var encPass = CryptoJS.AES.encrypt(fields.password, key, {iv:iv,mode:CryptoJS.mode.CBC,padding:CryptoJS.pad.ZeroPadding}).toString();
                    //console.log("encode value=", encPass)
                    fields.password = encPass;
                
                    // console.log("DEcode values=", CryptoJS.AES.decrypt(encPass,key,{iv:iv,padding:CryptoJS.pad.ZeroPadding}).toString(CryptoJS.enc.Utf8));
                  }
                props.dispatch(login(fields))
            }
        );

        this.state = { fields: { userName: '', password: '' ,confirmationMessage:'', captcha:''},  showModalPopup: false , inputErrors: {} };
    }
    componentDidMount() {
        $('input[type=password]').bind('cut copy paste', function (e) {
            e.preventDefault();
        });
        particleground(document.getElementById('particles'), {
            dotColor: '#478ecd',
            lineColor: '#478ecd'
        });
       this.props.dispatch(getcsrf())
    }
    /**
     * Check whether reponse is valid or not
     * If valid, then store the user details into local storage and redirect the user to authorized pages
     *
     * @param object
     */
    checkLogin(props) {
        const response = props.login.response;
        // Check whether response status is success or not. If success, then allow user to login. If fail, then display the error message
        if (response.status && response.status === 200 && Object.keys(response.data).length > 0) {
            props.auth.login(props.login.response.data);
            if (props.auth.isLoggedIn()) {
                props.auth.redirectAfterLogin(props);
            }
        }
        else {
            this.loginError(props);
        }
    }

    /**
     * Display error message
     *
     * @param object
     */
    loginError(props) {
        const response = props.login.response;
        if(response.message == "You are already logged-in on another device. To logout and login here click ok" || response.message =="لقد قمت بتسجيل الدخول بالفعل على جهاز آخر. لتسجيل الخروج وتسجيل الدخول هنا انقر فوق موافق")
        {
         this.props.dispatch(getcsrf())
         this.delete.handleToogleModalRelogin({ data: this.state.fields, url: 'login' }); 
        }

        else if(response.message == "validate privicy" ||response.message == 'التحقق من صحة الخصوصية')
        {
            this.props.dispatch(getcsrf())
            this.delete.handleToogleModal({ data: this.state.fields, url: 'login' })    
         }
    
     else if(response.message=="Please change your current password to proceed" || response.message== 'يرجى تغيير كلمة المرور الحالية الخاصة بك للمتابعة') {
        this.data1 = this.state.fields;
        if(localStorage.getItem('language')=="ar"){
            response.message=this.props.locale.forgotpassword.login_pass_error1
        }
        // this.passWord.handleToogleModal({ data: this.state.fields, url: 'login' })
        props.history.push("/update/password");
     }else if (response.message == "Your password has expired, please change to proceed" || response.message == 'لقد انتهت صلاحية كلمة المرور الخاصة بك ، يرجى التغيير للمتابعة') {
        this.data1 = this.state.fields;
        if(localStorage.getItem('language')=="ar"){
            response.message=this.props.locale.forgotpassword.login_pass_error2
        }
        // this.passWord.handleToogleModal({ data: this.state.fields, url: 'login' })
        props.history.push("/update/password");
      }else{
        toastr.error(response.message ? response.message : this.props.locale.common.login.fail);
		this.props.dispatch(getcsrf());
        this.setState({ fields: {...this.state.fields,password : ""}})
    }
    }

    /**
     * Handle the login process
     * If receive the response with valid data, then user will be redirected to authenticated homepage.
     * Otherwise the error message will display
     *
     * @param object props
     */
    handleLogin(props) {
        const response = props.login.response;
        // Check whether response is success or not. If success, then allow user to logindo further login process. If fail, then display the error message
        if (!props.login.isFetching && !props.login.isError && Object.keys(response).length > 0) {
            this.checkLogin(props);
        }
        else if (!props.login.isFetching && props.login.isError) {
            this.loginError(props);
        }
    }

    /**
     * Method is invoked whenever componnet receives new props.
     * If you need to update the state in response to prop changes,
     * you may compare this.props and nextProps and perform state transitions using
     * this.setState() in this method.
     *
     * @param object - nextProps - Component next props
     */
    componentWillReceiveProps(nextProps) {
        if (nextProps.login.response !== this.props.login.response) {
            this.handleLogin(nextProps);
        }
        if(nextProps.getcsrf.response != this.props.getcsrf.response){
            localStorage.setItem("csrftoken",nextProps.getcsrf.response.csrfToken);
        }
    }

    render() {
        return <div  className={localStorage.getItem('country')=="sa"?"main-login2" :"main-login"} id="particles">
            <div className="tcl-login">
                <h1><span>{this.props.locale.forgotpassword.confidently} </span> {this.props.locale.forgotpassword.connect_monitor}<span> {this.props.locale.forgotpassword.and} </span> {this.props.locale.forgotpassword.control} <span>{this.props.locale.forgotpassword.new_things_everyday}</span></h1>
            </div>
            <div className="login">
                <h1>
                {localStorage.getItem('country')=="sa" ? 
                    <img src={img}  width="180"  className="logo-symbol"></img>:
                    <a href="javascript:void(0)" className="logo-symbol">
                        {tataLogo()}
                   </a>}
                   {localStorage.getItem('country')!="sa" ?
                    <a href="javascript:void(0)" className="logo">
                        {tataLogoText()}
                    </a>:""}
                </h1>
                <form onSubmit={this.signin.handleSubmit} method="POST" autoComplete="off">
                    <h2>{this.props.locale.forgotpassword.sign_in}</h2>
                    <div className="form-group">
                        <label>{this.props.locale.customer.form.username}</label>
                        <div className="form-group-content">
                            <input type="text" placeholder={this.props.locale.customer.form.username} onBlur={this.signin.blurEventListner} onChange={this.signin.handleFieldsChange} value={this.state.fields.userName} name="userName" data-validation-name={this.props.locale.customer.form.username} autocomplete="new-password"/>
                            <span className="username-ic"></span>
                            <span className="wrong"></span>
                            <span className="sucess"></span>
                        </div>
                        {this.state.inputErrors.userName && this.state.inputErrors.userName.has && <p className="error-msg">{this.state.inputErrors.userName.message}</p>}
                    </div>
                    <div className="form-group">
                        <label>{this.props.locale.customer.form.password}</label>
                        <div className="form-group-content">
                            <input type="password" placeholder={this.props.locale.customer.form.password} onChange={this.signin.handleFieldsChange} value={this.state.fields.password} name="password" data-validation-name={this.props.locale.customer.form.password} autocomplete="new-password"/>
                            <span className="pwd-ic"></span>
                            <span className="wrong"></span>
                            <span className="sucess"></span>
                        </div>
                        {this.state.inputErrors.password && this.state.inputErrors.password.has && <p className="error-msg">{this.state.inputErrors.password.message}</p>}
                    </div>
                    <div className="form-group">
                        <label>{this.props.locale.customer.form.captcha}</label>
                        <div className="form-group-content">
                            <input type="text" placeholder={this.props.locale.customer.form.captcha} onChange={this.signin.handleFieldsChange} value={this.state.fields.captcha} name="captcha" data-validation-name={this.props.locale.customer.form.captcha} autocomplete="new-password"/>
                            <span className="captcha1-ic">
                            <MdVerifiedUser size={17} />
                            </span>
                            <span className="wrong"></span>
                            <span className="sucess"></span>
                        </div>
                        {this.state.inputErrors.captcha && this.state.inputErrors.captcha.has && <p className="error-msg">{this.state.inputErrors.captcha.message}</p>}
                    </div>
                    <div class="form-group-two">
                    <div class="row-container">
                        <img style={{border: "1px solid #d3d3d3"}}
                        src={this.props.getcsrf.response?.captcha ? this.props.getcsrf.response.captcha : "iVBORw0KGgoAAAANSUhEUgAAAMgAAAAyCAIAAACWMwO2AAAAuUlEQVR4Ae3BMQEAAACCMO0fGkt4shWI9FYg0luBSG8FIr0ViPRWINJbgUhvBSK9FYj0ViDSW4FIbwUivRWI9FYg0luBSG8FIr0ViPRWINJbgUhvBSK9FYj0ViDSW4FIbwUivRWI9FYg0luBSG8FIr0ViPRWINJbgUhvBSK9FYj0ViDSW4FIbwUivRWI9FYg0luBSG8FIr0ViPRWINJbgUhvBSK9FYj0ViDSW4FIbwUivRWI9FYg0tsAvduVnb5Qf7MAAAAASUVORK5CYII="}
                        alt="Base64 Image"
                        class="base64-image"
                        />
                        <a href="javascript:void(0)" class="captcha-ic" onClick={()=>{ 
                        this.props.dispatch(getcsrf())}}>
                        <span class="tooltip">Reset</span>
                        </a>
                    </div>
                    </div>

                    <LocaleSelector/>
                    <SubmitButton className="loginbbt" text={this.props.locale.login.login} response={this.props.login} />
                    <NavLink to="/forgot/password" className="forgetpassword">{this.props.locale.login.forgetpassword}</NavLink>
                </form>
                {localStorage.getItem('country')=="sa" ?
                <div className="bottomfooter"> 
                    <h3>{this.props.locale.forgotpassword.powered_by}</h3>
                    <img src={img2}  width="200" style ={{marginTop:"10px"}} className="footer-logo"></img>
                    <h3 className='copyright'>{this.props.locale.login.copyrightInfo}</h3>
                </div>:<div className="bottomfooter"> 
                    <h3 className='copyright'>{this.props.locale.login.copyrightInfo}</h3>
                </div>}
                <Delete
                  {...this.props}
                  permission={this.props.deletePermission}
                  ref={instance => {
                    this.delete = instance;
                  }} 
                />

            </div>
        </div>
    }
}

export default connect((state) => {
    return { login: state.login,getcsrf:state.getcsrf };
})(Login);
